import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ed69c6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-payment" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_view_header = _resolveComponent("view-header")!
  const _component_select_payment_method = _resolveComponent("select-payment-method")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_view_header, {
      text: _ctx.$t('cashier.header.new-order-payment')
    }, null, 8, ["text"]),
    _createVNode(_component_select_payment_method)
  ]))
}